import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { Project } from '../../data/mockProjects';

interface ProjectFormProps {
  onSubmit: (project: Omit<Project, 'id'>) => void;
  onCancel: () => void;
}

export const ProjectForm: React.FC<ProjectFormProps> = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    title: '',
    status: 'Declaración' as Project['status'],
    leadInventor: '',
    technologies: '',
    description: '',
  });
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const newProject: Omit<Project, 'id'> = {
      title: formData.title,
      status: formData.status,
      leadInventor: formData.leadInventor,
      technologies: formData.technologies.split(',').map(t => t.trim()).filter(t => t),
      createdDate: new Date().toISOString(),
      description: formData.description,
    };
    
    onSubmit(newProject);
  };
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Título del Proyecto *"
        name="title"
        value={formData.title}
        onChange={handleChange}
        placeholder="Ej: Sistema de Diagnóstico Médico con IA"
        required
      />
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Estado *
        </label>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        >
          <option value="Declaración">Declaración</option>
          <option value="Evaluación">Evaluación</option>
          <option value="Protección">Protección</option>
          <option value="Negociación">Negociación</option>
          <option value="Licenciado">Licenciado</option>
        </select>
      </div>
      
      <Input
        label="Inventor Principal *"
        name="leadInventor"
        value={formData.leadInventor}
        onChange={handleChange}
        placeholder="Ej: Dr. María González"
        required
      />
      
      <Input
        label="Tecnologías (separadas por comas) *"
        name="technologies"
        value={formData.technologies}
        onChange={handleChange}
        placeholder="Ej: Inteligencia Artificial, Machine Learning, Salud Digital"
        required
      />
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Descripción
        </label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Descripción detallada del proyecto..."
        />
      </div>
      
      <div className="flex justify-end space-x-3 pt-4">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button type="submit" variant="primary">
          Registrar Proyecto
        </Button>
      </div>
    </form>
  );
};
